export const COMMIT_SEEN_EVENT = "commentSeen.commit";

export interface CommitSeenEventData {
  commentIDs?: string[];
}
